export const CUSTOMERS_HEAD_CELLS = [
  {
    id: 'flatNumber',
    numeric: false,
    disabledPadding: true,
    label: 'Flat Number',
  },
  {
    id: 'firstName',
    numeric: false,
    disabledPadding: false,
    label: 'First Name',
  },
  {
    id: 'lastName',
    numeric: false,
    disabledPadding: false,
    label: 'Last Name',
  },
  {
    id: 'email',
    numeric: false,
    disabledPadding: false,
    label: 'Email',
  },
  {
    id: 'phoneNumber',
    numeric: false,
    disabledPadding: false,
    label: 'Phone number',
  },
  {
    id: 'hasGarage',
    numeric: false,
    disabledPadding: false,
    label: 'Garage',
  },
  {
    id: 'buildingName',
    numeric: false,
    disabledPadding: false,
    label: 'Building name',
  },
  {
    id: 'entranceName',
    numeric: false,
    disabledPadding: false,
    label: 'Entrance name',
  },
  {
    id: 'identificationCard',
    numeric: false,
    disabledPadding: false,
    label: 'ID',
  },
  {
    id: 'status',
    numeric: false,
    disabledPadding: false,
    label: 'Status',
  },
  {
    id: 'createdAt',
    numeric: false,
    disabledPadding: true,
    label: 'Created at',
  },
];

export const CUSTOMERS_DATA_CELLS = [
  'flatNumber',
  'firstName',
  'lastName',
  'email',
  'phoneNumber',
  'hasGarage',
  'buildingName',
  'entranceName',
  'identificationCard',
  'status',
  'createdAt',
];

export const PAYMENTS_HEAD_CELLS = [
  {
    id: 'firstName',
    numeric: false,
    disabledPadding: true,
    label: 'First Name',
  },
  {
    id: 'lastName',
    numeric: false,
    disabledPadding: false,
    label: 'Last Name',
  },
  {
    id: 'email',
    numeric: false,
    disabledPadding: false,
    label: 'Email',
  },
  {
    id: 'phoneNumber',
    numeric: false,
    disabledPadding: false,
    label: 'Phone number',
  },
  {
    id: 'flatNumber',
    numeric: false,
    disabledPadding: false,
    label: 'Flat Number',
  },
  {
    id: 'buildingName',
    numeric: false,
    disabledPadding: false,
    label: 'Building name',
  },
  {
    id: 'entranceName',
    numeric: false,
    disabledPadding: false,
    label: 'Entrance name',
  },
  {
    id: 'identificationCard',
    numeric: false,
    disabledPadding: false,
    label: 'ID',
  },
  {
    id: 'contract',
    numeric: false,
    disabledPadding: false,
    label: 'Contract',
  },
];

export const PAYMENTS_DATA_CELLS = [
  'firstName',
  'lastName',
  'email',
  'phoneNumber',
  'flatNumber',
  'buildingName',
  'entranceName',
  'identificationCard',
  'contract',
];
